import axios from "./axios-handler.service";
const BASE_URL = "/api/Importacao";

export interface ValidaProduto {
  precoDiferente: boolean;
  validoAte: string;
  inexistente: boolean;
  dataInvalida: boolean;
  historicoParaAlterar: string;
  produto: ProdutoCrawler;
  invalido: boolean;
}
export interface ProdutoCrawler {
  codigo: string;
  nome: string;
  valorUnitario: number;
  pontos: number;
  disponivel: boolean;
}
export class ImportacaoService {
  static async validarProdutosMK(txtHtml: string): Promise<ValidaProduto[]> {
    const response = await axios.post(`${BASE_URL}/ValidarProdutosMK`, {
      txtHtml,
    });
    return response.data;
  }

  static async validarProdutos(idCatalogo: string, json: File) {
    const body = new FormData();
    body.append(json.name, json);

    const response = await axios.post(`${BASE_URL}/ValidarProdutosCatalogo`, body, {
      params: { idCatalogo }
    });
    return response.data;
  }

  static async estenderHistorico(id: string): Promise<string> {
    const response = await axios.post(`${BASE_URL}/EstenderHistorico`, {
      id,
    });
    return response.data;
  }
}
